import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { WagmiProvider, createConfig } from "wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConnectKitProvider, getDefaultConfig } from "connectkit";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import App from "./App";
import "./index.css";
import { apechain } from "./lib/wagmi";
import { http } from "viem";
import { CONFIG } from "./config";

// Configure React Query client with default options
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 30_000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

// Configure wagmi with ConnectKit
const config = createConfig(
  getDefaultConfig({
    chains: [apechain],
    transports: {
      [apechain.id]: http("https://apechain-mainnet.g.alchemy.com/v2/J2mi4iTW__oS5fOtKYm2w-JcUvWd1SIx"),
    },
    walletConnectProjectId: CONFIG.REOWN_PROJECT_ID,
    appName: "DengSniper",
    appDescription: "Your essential tool for uncovering tokens actively mining in the Frostbyte Mines",
    appUrl: window.location.href,
    appIcon: "https://example.com/logo.png",
  })
);

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <ConnectKitProvider
          customTheme={{
            "--ck-font-family": "inherit",
            "--ck-border-radius": "16px",
            "--ck-overlay-background": "rgba(0, 0, 0, 0.6)",
            "--ck-overlay-backdrop-filter": "blur(4px)",
            "--ck-primary-button-background": "#2563eb",
            "--ck-primary-button-hover-background": "#1d4ed8",
            "--ck-primary-button-border-radius": "999px",
            "--ck-body-background": "rgba(3, 10, 33, 0.95)",
            "--ck-body-background-secondary": "rgba(3, 10, 33, 0.95)",
            "--ck-body-background-tertiary": "rgba(3, 10, 33, 0.95)",
            "--ck-modal-box-shadow": "0 0 30px rgba(37, 99, 235, 0.3)",
            "--ck-focus-color": "rgba(37, 99, 235, 0.4)",
            "--ck-modal-heading-font-weight": "700",
          }}
          options={{
            hideBalance: false,
            hideTooltips: false,
            embedGoogleFonts: false,
            walletConnectName: "WalletConnect",
            enforceSupportedChains: true,
            initialChainId: apechain.id,
            overlayBlur: 4,
            modalSize: "wide",
            customAvatar: undefined,
            disableSiweRedirect: true,
            cssOverrides: {
              modalContent: {
                position: "fixed",
                top: "80px",
                right: "20px",
                maxWidth: "420px",
                width: "100%",
                margin: "0",
                transform: "none",
              },
              overlay: {
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                backdropFilter: "blur(4px)",
              }
            }
          }}>
          <App />
          <Analytics mode="production" />
          <SpeedInsights />
        </ConnectKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </StrictMode>
);